// @ts-strict-ignore
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, tap } from 'rxjs';
import { filter } from 'rxjs/operators';
import { filterDefined } from '../../functions/rxjs-pipes/filter-defined';
import { AnalyticsService } from '../../services/analytics.service';
import { routerEffectsActions } from '../router/router.actions';
import { UserFacadeService } from '../user/user-facade.service';

@Injectable()
export class TenantsEffects {
  private _analyticsService = inject(AnalyticsService);
  private _actions$ = inject(Actions);
  private _userFacadeService = inject(UserFacadeService);

  setTenantForAnalytics$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(routerEffectsActions.routeTenantIdChanged),
        map((action) => action.tenantId),
        filterDefined,
        mergeMap((id) =>
          this._userFacadeService.user$.pipe(
            filter((user) => user !== null),
            map((user) => ({ id, user }))
          )
        ),
        map(({ id, user }) => {
          const tenantInMe = user.tenants?.find((t) => t.id === id);
          if (tenantInMe) {
            return { id, name: tenantInMe.name };
          }
          return null;
        }),
        // only possible to have analytics set on tenant if the tenant is found in the user object
        tap((tenant) => {
          if (tenant) {
            this._analyticsService.setTenant(tenant.id);
          } else {
            this._analyticsService.setTenant('');
          }
        })
      ),
    { dispatch: false }
  );
}
